// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__1DuzG","h3":"Heading_h3__yGtVh","dark":"Heading_dark__GuCLR","h4":"Heading_h4__vdVNj"};